// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"272":"223b82d5","803":"494261c5"}[chunkId] + ".css";
};